import { render, staticRenderFns } from "./qxgl.vue?vue&type=template&id=18f68bbc&scoped=true&"
import script from "./qxgl.vue?vue&type=script&lang=js&"
export * from "./qxgl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f68bbc",
  null
  
)

export default component.exports